<div class="table-wrapper__filter">
  <ng-content select="[tableFilter]" />
</div>

<div class="table-wrapper__content" *rpSpinner="shouldShowSpinner()">
  <ng-content select="[tableBody]" />
</div>
